import { useState } from "react";

export interface LocalizedPrice {
  formatted: string;
  currency: string;
}

/**
 * Preços estáticos (USD) definidos pelo site.
 * Antes resolvia preços localizados via Paddle.PricePreview; o Dite Gateway não
 * tem preview de preço por geolocalização, então retornamos os valores fixos.
 */
export function useLocalizedPrices(
  priceIds: string[],
  fallbacks: Record<string, string>,
): { prices: Record<string, LocalizedPrice>; loading: boolean; currency: string } {
  const [prices] = useState<Record<string, LocalizedPrice>>(() => {
    const init: Record<string, LocalizedPrice> = {};
    for (const id of priceIds) {
      init[id] = { formatted: fallbacks[id] ?? "", currency: "USD" };
    }
    return init;
  });

  return { prices, loading: false, currency: "USD" };
}
